import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DashboardCardTitle } from './DashboardStyles';

const CardContentComponent = ({ path, text, isExternal }) => {
  const { t } = useTranslation();

  return (
    <>
      {!isExternal && (
        <NavLink to={path}>
          <DashboardCardTitle variant='subtitle1' color='primary'>
            {t(text)}
          </DashboardCardTitle>
        </NavLink>
      )}
      {isExternal && (
        <a href={path} target='_blank' rel='noopener noreferrer'>
          <DashboardCardTitle variant='subtitle1' color='primary'>
            {t(text)}
          </DashboardCardTitle>
        </a>
      )}
    </>
  );
};

CardContentComponent.propTypes = {
  path: PropTypes.string,
  text: PropTypes.string,
  isExternal: PropTypes.bool
};

export default CardContentComponent;
